export default "__VITE_ASSET__CRKn3KsW__"